import { useEffect, useState } from 'react';
import { useFonte } from '../dados/contexto.js';
import type { Midia } from '../dados/fonte.js';
import { Foto } from './ui/index.js';

/**
 * Endereco para exibir o arquivo de uma midia: o blob do aparelho (enquanto nao
 * subiu) ou um link assinado do Storage. O blob vira object URL, que e revogado
 * quando o componente sai da tela — senao a memoria do tablet vai embora foto a foto.
 */
export function useUrlDaMidia(midia: Midia | null | undefined): string | null {
  const fonte = useFonte();
  const [url, setUrl] = useState<string | null>(null);
  const chave = midia ? `${midia.id}|${midia.storage_path ?? ''}|${midia.pendente}` : '';

  useEffect(() => {
    if (!midia) {
      setUrl(null);
      return;
    }
    let vivo = true;
    let criada: string | null = null;
    fonte.urlDaMidia(midia).then(
      (u) => {
        if (!vivo) {
          if (u?.startsWith('blob:')) URL.revokeObjectURL(u);
          return;
        }
        criada = u;
        setUrl(u);
      },
      () => vivo && setUrl(null),
    );
    return () => {
      vivo = false;
      if (criada?.startsWith('blob:')) URL.revokeObjectURL(criada);
    };
    // A chave resume o que muda o arquivo; o objeto `midia` e recriado a cada consulta.
  }, [fonte, chave]);

  return url;
}

/** A foto de uma midia, ou o simbolo quando nao ha arquivo para mostrar. */
export function FotoDaMidia({
  midia,
  className,
  legenda,
  alt = '',
}: {
  midia: Midia | null | undefined;
  className?: string;
  legenda?: string;
  alt?: string;
}) {
  const url = useUrlDaMidia(midia?.kind === 'foto' ? midia : null);
  return <Foto className={className ?? ''} src={url} alt={alt} {...(url ? {} : legenda ? { legenda } : {})} />;
}
